export default [

  {
    "themeName": "绀青",
    // gangqing
    "src": "/static/theme/gangqing/index.css",
    "style": {
      "--primary-color": "#245BBF",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#CFD5E0",
      "--primary-mix1": "#CFD5E0",
      "--primary-mix2": "#BDC8DC",
      "--primary-mix3": "#A9BAD9",
      "--primary-mix4": "#97ADD5",
      "--primary-mix5": "#849FD2",
      "--primary-mix6": "#7091CD",
      "--primary-mix7": "#5D83CA",
      "--primary-mix8": "#4A76C6",
      "--primary-mix9": "#3769C3",

      /* 导航栏 */
      "--nav-backgroud-color": "#042663",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#D8E6FF",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#042663",
    }
  },
  {
    "themeName": "石青",
    // shiqing
    "src": "/static/theme/shiqing/index.css",
    "style": {
      "--primary-color": "#03758B",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E6F1F3",
      "--primary-mix1": "#E6F1F3",
      "--primary-mix2": "#CCE4E8",
      "--primary-mix3": "#B2D5DB",
      "--primary-mix4": "#99C8D0",
      "--primary-mix5": "#80B8C5",
      "--primary-mix6": "#67ADB9",
      "--primary-mix7": "#4F9EAD",
      "--primary-mix8": "#3590A2",
      "--primary-mix9": "#1B8295",

      /* 导航栏 */
      "--nav-backgroud-color": "#003B47",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#E1FAFF",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#003B47",
    }
  },
  {
    "themeName": "宝蓝",
    // baolan
    "src": "/static/theme/baolan/index.css",
    "style": {
      "--primary-color": "#1A81CF",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E7F2FA",
      "--primary-mix1": "#E7F2FA",
      "--primary-mix2": "#D1E6F6",
      "--primary-mix3": "#B9D9F1",
      "--primary-mix4": "#A3CCEC",
      "--primary-mix5": "#8CC0E7",
      "--primary-mix6": "#75B3E2",
      "--primary-mix7": "#5EA6DD",
      "--primary-mix8": "#479AD8",
      "--primary-mix9": "#308DD3",

      /* 导航栏 */
      "--nav-backgroud-color": "#13598E",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#DEF0FE",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#13598E",
    }
  },
  {
    "themeName": "赭石",
    // zheshi
    "src": "/static/theme/zheshi/index.css",
    "style": {
      "--primary-color": "#994F06",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#F5EDE5",
      "--primary-mix1": "#F5EDE5",
      "--primary-mix2": "#EBDCCD",
      "--primary-mix3": "#E0CAB3",
      "--primary-mix4": "#D6B89B",
      "--primary-mix5": "#CCA682",
      "--primary-mix6": "#C29569",
      "--primary-mix7": "#B78350",
      "--primary-mix8": "#AD7237",
      "--primary-mix9": "#A3601E",

      /* 导航栏 */
      "--nav-backgroud-color": "#7D3E00",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#FEF3E9",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#7D3E00",
    }
  },

  {
    "themeName": "绛紫",
    // jiangzi
    "src": "/static/theme/jiangzi/index.css",
    "style": {
      "--primary-color": "#78359A",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#F1EAF5",
      "--primary-mix1": "#F1EAF5",
      "--primary-mix2": "#E4D6EB",
      "--primary-mix3": "#D6C2E0",
      "--primary-mix4": "#C9AED6",
      "--primary-mix5": "#BB99CC",
      "--primary-mix6": "#AE85C2",
      "--primary-mix7": "#A071B8",
      "--primary-mix8": "#935DAE",
      "--primary-mix9": "#8548A3",

      /* 导航栏 */
      "--nav-backgroud-color": "#531659",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#F8ECFE",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#531659",
    }
  },


  // todo   加图片
  {
    "themeName": "紫棠",
    // zitang
    "spec": true,
    "showBox": '/static/img/zitang.png',
    "src": "/static/theme/zitang/index.css",
    "style": {
      "--primary-color": "#78359A",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#F1EAF5",
      "--primary-mix1": "#F1EAF5",
      "--primary-mix2": "#E4D6EB",
      "--primary-mix3": "#D6C2E0",
      "--primary-mix4": "#C9AED6",
      "--primary-mix5": "#BB99CC",
      "--primary-mix6": "#AE85C2",
      "--primary-mix7": "#A071B8",
      "--primary-mix8": "#935DAE",
      "--primary-mix9": "#8548A3",

      /* 导航栏 */
      // "--nav-backgroud-color": "#531659",
      "--nav-backgroud-color": "#531659 url('/static/img/zitang1.jpg')",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#F6EAFC",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      // "--header-backgroud-color": "#531659",
      "--header-backgroud-color": "#531659 url('/static/img/zitang2.jpg')",
    }
  },


  {
    "themeName": "华青",
    // huaqing
    "showBox": '/static/img/huaqing.png',
    "spec": true,
    "src": "/static/theme/huaqing/index.css",
    "style": {
      "--primary-color": "#02559D",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E5EDF5",
      "--primary-mix1": "#E5EDF5",
      "--primary-mix2": "#CCDDEB",
      "--primary-mix3": "#B2CBE1",
      "--primary-mix4": "#99BBD8",
      "--primary-mix5": "#80A9CE",
      "--primary-mix6": "#6799C4",
      "--primary-mix7": "#4D87BA",
      "--primary-mix8": "#3477B0",
      "--primary-mix9": "#1A65A6",
      /* 导航栏 */
      // "--nav-backgroud-color": "#02559D",
      "--nav-backgroud-color": "#02559D url('/static/img/huaqing1.jpg')",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#DBEDFC",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      // "--header-backgroud-color": "#02559D",
      "--header-backgroud-color": "#02559D url('/static/img/huaqing2.jpg')",
    }
  },



  {
    "themeName": "黛绿",
    // dailv
    "showBox": '/static/img/dailv.png',
    "spec": true,
    "src": "/static/theme/dailv/index.css",
    "style": {
      "--primary-color": "#0F6975",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E6F0F1",
      "--primary-mix1": "#E6F0F1",
      "--primary-mix2": "#CFE1E3",
      "--primary-mix3": "#B6D1D5",
      "--primary-mix4": "#9FC3C8",
      "--primary-mix5": "#86B3B9",
      "--primary-mix6": "#6FA5AC",
      "--primary-mix7": "#56959E",
      "--primary-mix8": "#3F8790",
      "--primary-mix9": "#267782",
      /* 导航栏 */
      // "--nav-backgroud-color": "#0F6975",
      "--nav-backgroud-color": "#0F6975 url('/static/img/dailv1.jpg')",
      "--nav-backgroud-img": "/static/img/黛绿1.jpg",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#E5F8FB",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      // "--header-backgroud-color": "#0F6975",
      "--header-backgroud-color": "#0F6975 url('/static/img/dailv2.jpg')",

    }
  },


  {
    "themeName": "竹青",
    // zhuqing
    "showBox": '/static/img/zhuqing.png',
    "spec": true,
    "src": "/static/theme/zhuqing/index.css",
    "style": {
      "--primary-color": "#526103",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#EDEFE5",
      "--primary-mix1": "#EDEFE5",
      "--primary-mix2": "#DCDFCC",
      "--primary-mix3": "#CACFB2",
      "--primary-mix4": "#B9C09A",
      "--primary-mix5": "#A8AF80",
      "--primary-mix6": "#97A067",
      "--primary-mix7": "#85904E",
      "--primary-mix8": "#748035",
      "--primary-mix9": "#62701B",
      /* 导航栏 */
      "--nav-backgroud-color": "#526103 url('/static/img/zhuqing1.jpg')",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#F5F9DD",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#526103 url('/static/img/zhuqing2.jpg')",
    }
  },

  {
    "themeName": "宝石绿",
    // baoshilv
    "showBox": '/static/img/baoshilv.png',
    "spec": true,
    "src": "/static/theme/baoshilv/index.css",
    "style": {
      "--primary-color": "#17724E",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E7F1ED",
      "--primary-mix1": "#E7F1ED",
      "--primary-mix2": "#D0E3DB",
      "--primary-mix3": "#B9D4C9",
      "--primary-mix4": "#A2C6B8",
      "--primary-mix5": "#8AB8A6",
      "--primary-mix6": "#73AA94",
      "--primary-mix7": "#5C9C82",
      "--primary-mix8": "#458E71",
      "--primary-mix9": "#2D7F5F",
      /* 导航栏 */
      "--nav-backgroud-color": "#17724E url('/static/img/baoshi1.jpg')",
      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#DBFBEE",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      // "--header-backgroud-color": "#17724E",
      "--header-backgroud-color": "#17724E url('/static/img/baoshi2.jpg')",
    }
  },


  {
    "themeName": "藏蓝",
    // zhanglan
    "showBox": '/static/img/zhanglan.png',
    "spec": true,
    "src": "/static/theme/zhanglan/index.css",
    "style": {
      "--primary-color": "#2A4292",
      "--table-header-bcolor": "#F7F7F7",
      "--primary-mix05": "#E9EBF4",
      "--primary-mix1": "#E9EBF4",
      "--primary-mix2": "#D4D9E9",
      "--primary-mix3": "#BEC6DE",
      "--primary-mix4": "#A9B3D3",
      "--primary-mix5": "#94A0C8",
      "--primary-mix6": "#7F8DBD",
      "--primary-mix7": "#697AB2",
      "--primary-mix8": "#5467A7",
      "--primary-mix9": "#3E549C",
      /* 导航栏 */
      // "--nav-backgroud-color": "#2A4292",
      "--nav-backgroud-color": "#2A4292 url('/static/img/zanglan1.jpg')",

      "--nav-ul-backgroud-color": "#fff",
      "--nav-ul-font-color": "#333",
      "--nav-ul-active-backgroud-color": "#E8EDFC",
      "--nav-ul-active-font-color": "#333",


      /* 头部颜色*/
      "--header-backgroud-color": "#2A4292 url('/static/img/zanglan2.jpg')",
      // "--header-backgroud-img": "/static/img/藏蓝2.jpg",
    }
  },
]
